import MatrixGallery_MatrixGalleryTransparentSkinComponent from '../components/NativeGalleries/MatrixGallery/viewer/skinComps/MatrixGalleryTransparentSkin/MatrixGalleryTransparentSkin.skin';
import MatrixGallery_MatrixGalleryTransparentSkinController from '../components/NativeGalleries/MatrixGallery/viewer/MatrixGallery.controller';


const MatrixGallery_MatrixGalleryTransparentSkin = {
  component: MatrixGallery_MatrixGalleryTransparentSkinComponent,
  controller: MatrixGallery_MatrixGalleryTransparentSkinController
};


export const components = {
  ['MatrixGallery_MatrixGalleryTransparentSkin']: MatrixGallery_MatrixGalleryTransparentSkin
};

